export default __webpack_public_path__ + "static/media/3106.b0c4aff6.jpg";